export const FaqRcf = [
  {
    'title': 'What is a Cash Flow Facility?',
    'content': 'You can tap into this pre-approved line of capital whenever you need business funding, without having to reapply. And because we don’t charge any hidden monthly admin or initiation fees, you’ll only ever pay for the funds you use. A Cash Flow Facility is a line of capital you can tap into when you need business funding, without having to reapply. Your facility limit is subject to ongoing credit and affordability assessments'
  },
  {
    'title': 'How do I apply for a Cash Flow Facility?',
    'content': 'Our online application process takes only minutes and is paperless. Simply supply us with your basic personal and business details. We\u2019ll also ask for 3 months\u2019 latest business bank statement data.'
  },
  {
    'title': 'What is the benefit of a Cash Flow Facility?',
    'content': 'It offers easy access to working capital whenever you need it, allowing you to take advantage of growth opportunities or cover any cash flow gaps.'
  }
];